import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Pipe({
  name: 'getTags'
})
export class GetTagsPipe implements PipeTransform {
  transform(f: AbstractControl<any>): string[] {
    let input = f.value;
    if (Array.isArray(input)) {
      const uniqueTagsSet = new Set(input.map(tag => tag.trim()));
      return Array.from(uniqueTagsSet);
    } else if (typeof input === 'string' && input.trim() !== '') {
      const tagsArray = input.trim().split(' ');
      const uniqueTagsSet = new Set(tagsArray);
      return Array.from(uniqueTagsSet);
    } else {
      return [];
    }
  }
}
